export default __webpack_public_path__ + "static/media/brand3.2957ea2f.png";